<template>
    <div class="question-object">
        <span class="question-object__label">SÖZCÜK</span>
        <span class="question-object__value">/{{ value }}/</span>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                type: String,
                default: 'lokum',
            },
        },
    };
</script>
<style scoped src="@/css/components/question-object-phonetic-transcription.css"></style>